import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../hooks/useSeo";
import { Reveal } from "../components/motion/Reveal";

export default function LegalPage({ kind, title }) {
  const [content, setContent] = useState("");

  useSeo({ title: `${title} | Pantheon Art`, path: `/${kind === "privacy_policy" ? "privacy-policy" : "terms-of-service"}` });

  useEffect(() => {
    api
      .get("/settings/site")
      .then((res) => setContent(res.data?.[kind] || ""))
      .catch(() => {});
  }, [kind]);

  return (
    <div className="px-5 pb-24 pt-32 lg:px-10 lg:pt-40" data-testid={`legal-${kind}`}>
      <Reveal>
        <h1 className="h-condensed text-[clamp(2.5rem,6vw,5rem)]">{title}</h1>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="rich-text hairline-t mt-10 pt-10" dangerouslySetInnerHTML={{ __html: content }} />
      </Reveal>
    </div>
  );
}
